import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../../api';
import DashboardLayout from '../../../Components/Dashboard/DashboardLayout';
import './AdminSuite.css';

const AdminServicesPage = () => {
  const navigate = useNavigate();
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      setLoading(true);
      const res = await api.get('/admin/services');
      setServices(res.data || []);
    } catch {
      toast.error('Failed to load services');
    } finally {
      setLoading(false);
    }
  };

  const togglePublished = async (service) => {
    try {
      await api.put(`/services/${service.id}`, { published: !service.published });
      toast.success(service.published ? 'Service unpublished' : 'Service published');
      load();
    } catch {
      toast.error('Failed to update service');
    }
  };

  const deleteService = async (id) => {
    if (!window.confirm('Are you sure you want to delete this service?')) return;
    try {
      await api.delete(`/services/${id}`);
      toast.success('Service deleted');
      load();
    } catch {
      toast.error('Failed to delete service');
    }
  };

  return (
    <DashboardLayout>
      <div className="container py-4 admin-suite">
        <div className="admin-suite-header">
          <div>
            <h3 className="admin-suite-title">Footer Services</h3>
            <p className="admin-suite-subtitle">Manage the services shown in the website footer.</p>
          </div>
          <button className="btn btn-primary" onClick={() => navigate('/admin/services/create')}>
            + Add Service
          </button>
        </div>

        <div className="admin-table-wrap admin-card">
          <div className="admin-table-head" style={{ gridTemplateColumns: '2fr 2fr 1fr 1fr' }}>
            <div>Title</div>
            <div>Short Description</div>
            <div>Status</div>
            <div>Actions</div>
          </div>

          {loading && (
            <div className="p-3 text-muted">Loading…</div>
          )}

          {!loading && services.length === 0 && (
            <div className="p-3 text-muted">No services found. Create one above.</div>
          )}

          {!loading && services.map(service => (
            <div
              key={service.id}
              className="admin-table-row"
              style={{ gridTemplateColumns: '2fr 2fr 1fr 1fr' }}
            >
              <div>
                <strong>{service.title}</strong>
                <div className="text-muted small">Order: {service.sort_order}</div>
              </div>
              <div className="text-muted small">
                {service.short_description
                  ? service.short_description.length > 80
                    ? service.short_description.slice(0, 80) + '…'
                    : service.short_description
                  : <em>—</em>}
              </div>
              <div>
                <span className={`admin-pill ${service.published ? 'published' : 'draft'}`}>
                  {service.published ? 'Published' : 'Draft'}
                </span>
              </div>
              <div className="admin-actions">
                <button
                  className="btn btn-sm btn-outline-secondary"
                  title={service.published ? 'Unpublish' : 'Publish'}
                  onClick={() => togglePublished(service)}
                >
                  {service.published ? 'Unpublish' : 'Publish'}
                </button>
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => navigate(`/admin/services/edit/${service.id}`)}
                >
                  Edit
                </button>
                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => deleteService(service.id)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AdminServicesPage;
